exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cursor-pointer[data-v-3c5ba8cb] {\n  cursor: pointer;\n}\n.isMain[data-v-3c5ba8cb] {\n  font-weight: bold;\n}\n.v-stepper__header[data-v-3c5ba8cb]{\n  height:50px;\n}\n.v-stepper__step[data-v-3c5ba8cb]{\n  padding:13px;\n}\n.v-stepper[data-v-3c5ba8cb]{\n  height:430px;\n}\n[data-v-3c5ba8cb] .v-list__tile{\n  height:32px;\n}\n[data-v-3c5ba8cb] .v-list__tile p{\n  margin-bottom:0;\n}\n.v-dialog__content[data-v-3c5ba8cb] {\n    z-index: 1030 !important;\n}\n", ""]);

// exports
